/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExternalProviderLegalForms } from './';
import {
    ExternalProviderLegalFormsFromJSON,
    ExternalProviderLegalFormsFromJSONTyped,
    ExternalProviderLegalFormsToJSON,
} from './';
import type { LegalNoticesForm } from './';
import {
    LegalNoticesFormFromJSON,
    LegalNoticesFormFromJSONTyped,
    LegalNoticesFormToJSON,
} from './';
import type { LegalPersonType } from './';
import {
    LegalPersonTypeFromJSON,
    LegalPersonTypeFromJSONTyped,
    LegalPersonTypeToJSON,
} from './';
import type { UserType } from './';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyTypeForm
 */
export interface CompanyTypeForm {
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeForm
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeForm
     */
    label: string;
    /**
     * 
     * @type {UserType}
     * @memberof CompanyTypeForm
     */
    userType: UserType;
    /**
     * 
     * @type {LegalPersonType}
     * @memberof CompanyTypeForm
     */
    legalPersonType: LegalPersonType;
    /**
     * 
     * @type {LegalNoticesForm}
     * @memberof CompanyTypeForm
     */
    legalNotices: LegalNoticesForm;
    /**
     * 
     * @type {Array<ExternalProviderLegalForms>}
     * @memberof CompanyTypeForm
     */
    legalFormMappings?: Array<ExternalProviderLegalForms>;
}

/**
 * Check if a given object implements the CompanyTypeForm interface.
 */
export function instanceOfCompanyTypeForm(value: object): value is CompanyTypeForm {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('userType' in value) || value['userType'] === undefined) return false;
    if (!('legalPersonType' in value) || value['legalPersonType'] === undefined) return false;
    if (!('legalNotices' in value) || value['legalNotices'] === undefined) return false;
    return true;
}

export function CompanyTypeFormFromJSON(json: any): CompanyTypeForm {
    return CompanyTypeFormFromJSONTyped(json, false);
}

export function CompanyTypeFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyTypeForm {
    if (json == null) {
        return json;
    }
    return {
        
        'language': json['language'] == null ? undefined : json['language'],
        'label': json['label'],
        'userType': UserTypeFromJSON(json['userType']),
        'legalPersonType': LegalPersonTypeFromJSON(json['legalPersonType']),
        'legalNotices': LegalNoticesFormFromJSON(json['legalNotices']),
        'legalFormMappings': json['legalFormMappings'] == null ? undefined : ((json['legalFormMappings'] as Array<any>).map(ExternalProviderLegalFormsFromJSON)),
    };
}

export function CompanyTypeFormToJSON(value?: CompanyTypeForm | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'language': value['language'],
        'label': value['label'],
        'userType': UserTypeToJSON(value['userType']),
        'legalPersonType': LegalPersonTypeToJSON(value['legalPersonType']),
        'legalNotices': LegalNoticesFormToJSON(value['legalNotices']),
        'legalFormMappings': value['legalFormMappings'] == null ? undefined : ((value['legalFormMappings'] as Array<any>).map((v) => ExternalProviderLegalFormsToJSON(v))),
    };
}

